import React from "react";

const VerifiedBuy = ({ width = "16px", height = "16px" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g fillRule="nonzero">
      <path
        d="M15.5709091,6.97454545 L14.08,5.48363636 L14.08,3.36727273 C14.08,2.56394945 13.4287778,1.91272727 12.6254545,1.91272727 L10.5163636,1.91272727 L9.02545455,0.458181818 C8.45812734,-0.105779774 7.54187266,-0.105779774 6.97454545,0.458181818 L5.48363636,1.92 L3.36727273,1.92 C2.56394945,1.92 1.91272727,2.57122218 1.91272727,3.37454545 L1.91272727,5.48363636 L0.458181818,6.97454545 C0.174320423,7.24123323 0.00927347893,7.61062401 -4.6379092e-07,8 C-0.000306517546,8.38410548 0.151330248,8.75273969 0.421818182,9.02545455 L1.92,10.5163636 L1.92,12.6327273 C1.92,13.4360505 2.57122218,14.0872727 3.37454545,14.0872727 L5.48363636,14.0872727 L6.97454545,15.5781818 C7.24726031,15.8486698 7.61589452,16.0003065 7.99999954,16.0000005 C8.38410548,16.0003065 8.75273969,15.8486698 9.02545455,15.5781818 L10.5163636,14.08 L12.6327273,14.08 C13.4360505,14.08 14.0872727,13.4287778 14.0872727,12.6254545 L14.0872727,10.5163636 L15.5781818,9.02545455 C16.1421434,8.45812734 16.1421434,7.54187266 15.5781818,6.97454545 L15.5709091,6.97454545 Z"
        fill="#15cad7"
      ></path>
      <polygon
        fill="#FFFFFF"
        points="7.27272727 8.53090909 5.60727273 6.86545455 4.57454545 7.89090909 7.27272727 10.5890909 11.4254545 6.43636364 10.3927273 5.41090909"
      ></polygon>
    </g>
  </svg>
);

export default VerifiedBuy;
